import React from 'react';

export default function ActivityLogModal({
  record,
  logs,
  loading,
  error,
  onClose,
}) {
  if (!record) return null;

  return (
    <div className="fixed inset-0 modal-backdrop flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-elevated w-full max-w-3xl max-h-[85vh] overflow-hidden animate-scale-in">
        <div className="px-7 py-5 border-b border-slate-100 flex items-center justify-between">
          <div>
            <h3 className="text-lg font-bold text-slate-900 tracking-tight">Activity Log</h3>
            <p className="text-sm text-slate-400 mt-0.5">{record.title}</p>
          </div>
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-xl bg-white border border-slate-200 text-slate-500 hover:bg-slate-50 hover:border-slate-300 text-sm font-medium transition-all"
          >
            Close
          </button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(85vh-80px)]">
          {loading && (
            <p className="text-sm text-slate-600">Loading record activity...</p>
          )}

          {!loading && error && (
            <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}

          {!loading && !error && logs.length === 0 && (
            <p className="text-sm text-slate-600">No activity has been logged for this record yet.</p>
          )}

          {!loading && !error && logs.length > 0 && (
            <div className="space-y-3">
              {logs.map((log) => (
                <div key={log.id} className="rounded-lg border border-slate-200 bg-white px-4 py-3">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <p className="text-sm font-semibold text-slate-900">{String(log.action || '').replace(/_/g, ' ')}</p>
                    <p className="text-xs text-slate-500">{log.timestamp ? new Date(log.timestamp).toLocaleString() : '-'}</p>
                  </div>
                  <p className="text-sm text-slate-600 mt-1">
                    {log.details?.title || log.details?.recordTitle || log.details?.description || '-'}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
